var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-sm px-2 py-1 rounded",class:`status_${_vm.status}`},[_vm._v(" "+_vm._s(_vm.$t(`sales_website.${_vm.status}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }